const carouselItems = [
  {
    tag: '热门推荐',
    title: '久久视频 · 高清影视专区',
    desc: '接入久久视频稳定片源，海量正版高清电影电视剧随心看，画质清晰流畅不卡顿',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20scene%20with%20warm%20red%20velvet%20curtains%20and%20golden%20stage%20lighting%2C%20film%20reel%20and%20clapperboard%20elements%2C%20elegant%20dark%20atmosphere%20with%20dramatic%20spotlight%2C%20luxury%20cinema%20aesthetic%2C%20high%20detail%20photography&width=800&height=500&seq=carousel-01&orientation=landscape',
    alt: '久久视频高清影视专区',
  },
  {
    tag: '最新上架',
    title: '小蓝视频 · 独家内容精选',
    desc: '小蓝视频独家授权内容每日上新，综艺娱乐、动漫番剧、纪录片一网打尽',
    img: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20with%20colorful%20video%20thumbnails%20in%20grid%20layout%2C%20blue%20and%20warm%20accent%20highlights%2C%20sleek%20dark%20theme%20UI%20design%2C%20digital%20entertainment%20concept%2C%20clean%20modern%20composition&width=800&height=500&seq=carousel-02&orientation=landscape',
    alt: '小蓝视频独家内容精选',
  },
  {
    tag: '免费畅看',
    title: '豆花视频 · 全集免费放送',
    desc: '豆花视频免费影视全集持续更新，热门剧集抢先看，无需付费解锁全部内容',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20scene%20with%20large%20TV%20screen%20displaying%20colorful%20movie%20content%2C%20soft%20ambient%20lighting%20from%20warm%20lamp%2C%20comfortable%20sofa%20with%20throw%20pillows%2C%20home%20entertainment%20vibe%2C%20evening%20atmosphere%2C%20cozy%20cinematic%20photography&width=800&height=500&seq=carousel-03&orientation=landscape',
    alt: '豆花视频免费影视全集',
  },
  {
    tag: '流畅体验',
    title: '极速引擎 · 零缓冲播放',
    desc: '自研智能加速技术，多线路自动切换，确保每次观看都流畅到底，告别卡顿等待',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20digital%20speed%20concept%20with%20flowing%20light%20trails%20and%20data%20streams%2C%20high%20speed%20network%20visualization%2C%20warm%20orange%20and%20gold%20gradient%20accents%20on%20dark%20background%2C%20sleek%20technology%20aesthetic%2C%20dynamic%20motion%20blur%20effect%2C%20modern%20digital%20art&width=800&height=500&seq=carousel-04&orientation=landscape',
    alt: '极速引擎零缓冲播放',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精选专题</h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
              聚合久久视频、小蓝视频、豆花视频优质内容，精选热门专题每日推荐
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {carouselItems.map((item, i) => (
              <article key={i} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer">
                <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.alt}
                    title={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-xs font-medium bg-primary-500/90 text-background-50 rounded-full">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}